<template>
  <AdviserChannelPage :channel="channel" />
</template>

<script>
  import { IFA_CHANNEL } from '@/constants/adviser-enrolment/ifa-content';
  import AdviserChannelPage from './AdviserChannelPage.vue';

  export default {
    name: 'IfaAdviserEnrolment',
    components: {
      AdviserChannelPage,
    },
    metaInfo: {
      meta: [
        {
          name: 'robots',
          content: 'nofollow',
        },
        {
          name: 'robots',
          content: 'noindex',
        },
      ],
    },
    data() {
      return {
        channel: IFA_CHANNEL,
      };
    },
  };
</script>
